<div class="categories">

  <div
    class="categories__title">
      3D Model Library
  </div>

  <div class="categories__results">
    <app-cards>
      <app-card
        *ngFor="let category of baseAnatomyCategories"
        [routerLink]="['/view']" 
        [queryParams]="{'id': category.id}"
        [showHover]="false">
      
        <div card-body>
          <div class="category__image" [ngClass]="category.image"></div>
          <div class="text-14 text-center">{{ category.title }}</div>
        </div>
      </app-card>
  
      <app-card
        *ngFor="let category of categories"
        [routerLink]="['/explore', category.tag]"
        [showHover]="false">
      
        <div card-body>
          <div class="category__image" [ngClass]="category.image"></div>
          <div class="text-14 text-center">{{ category.title }}</div>
        </div>
      </app-card>
    </app-cards>
  </div>
</div>